// A rule about the schema shape rather than about the editor, so it lives
// next to the editor instead of inside it — which also leaves that file
// exporting a component and nothing else.

import type { MetaFieldType } from "./MetaSchemaEditor";

/** The allow-list only makes sense for the string-ish types. The server says
 *  the same thing from the other side: `card.Field.accepts` consults `allowed`
 *  in its `string` and `string[]` branches and nowhere else. */
export function supportsAllowList(type: MetaFieldType): boolean {
  return type === "string" || type === "string[]";
}

/**
 * What a key of one of these schemas may be called.
 *
 * Exported rather than kept beside the editor because two things hold a schema
 * to it and they must not drift: the editor paints an offending row red, and
 * the page's own validator blocks Save on the same string
 * (`metaSchemaError`, `payloadSchemaProblem`). One of them relaxing the rule
 * while the other keeps it is a row that looks fine beside a grey button.
 */
export const SCHEMA_KEY_PATTERN = /^[a-z_][a-z0-9_]*$/;
